import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbDropdownModule, NgbModalModule, NgbDatepickerModule, NgbAlertModule, NgbTimepickerModule, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    NgbDropdownModule,
    NgbModalModule,
    NgbAlertModule,
    NgbDatepickerModule,
    NgbPaginationModule,
    NgbTimepickerModule
  ],
  exports: [
    NgbDropdownModule,
    NgbModalModule,
    NgbAlertModule,
    NgbDatepickerModule,
    NgbPaginationModule,
    NgbTimepickerModule
  ]
})
export class BootstrapModule { }
